// SafetyCulture-inspirierte React App.js (komplett)
import React, { useState, useEffect } from "react";
import "./App.css";

const USERS = [
  { email: "admin@voltax.ch", password: "123456", role: "admin" },
  { email: "user@xoltax.ch", password: "123456", role: "mitarbeiter" },
];

export default function App() {
  const [currentUser, setCurrentUser] = useState(() => {
    const saved = localStorage.getItem("sc_user");
    return saved ? JSON.parse(saved) : null;
  });

  const [inspections, setInspections] = useState(() => {
    const saved = localStorage.getItem("sc_inspections");
    return saved ? JSON.parse(saved) : [];
  });

  const [view, setView] = useState("list");
  const [loginData, setLoginData] = useState({ email: "", password: "" });

  const [form, setForm] = useState({
    ort: "",
    kategorie: "",
    beschreibung: "",
    dringlichkeit: "mittel",
    status: "Neu",
    bilder: [],
  });

  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    localStorage.setItem("sc_inspections", JSON.stringify(inspections));
  }, [inspections]);

  const handleLogin = () => {
    const user = USERS.find(
      (u) => u.email === loginData.email && u.password === loginData.password
    );
    if (user) {
      setCurrentUser(user);
      localStorage.setItem("sc_user", JSON.stringify(user));
    } else alert("Login fehlgeschlagen");
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const urls = files.map((file) => URL.createObjectURL(file));
    setForm((f) => ({ ...f, bilder: [...f.bilder, ...urls] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const entry = {
      ...form,
      erstelltVon: currentUser.email,
      erstelltAm: new Date().toLocaleString(),
    };
    setInspections((prev) => [...prev, entry]);
    setForm({ ort: "", kategorie: "", beschreibung: "", dringlichkeit: "mittel", status: "Neu", bilder: [] });
    setView("list");
  };

  const handleUpdate = (index, field, value) => {
    const updated = [...inspections];
    updated[index][field] = value;
    setInspections(updated);
  };

  const handleDelete = (index) => {
    if (window.confirm("Eintrag wirklich löschen?")) {
      const updated = [...inspections];
      updated.splice(index, 1);
      setInspections(updated);
    }
  };

  if (!currentUser)
    return (
      <div className="login-wrapper">
        <h2>🔐 Login</h2>
        <input type="email" placeholder="E-Mail" value={loginData.email} onChange={(e) => setLoginData({ ...loginData, email: e.target.value })} />
        <input type="password" placeholder="Passwort" value={loginData.password} onChange={(e) => setLoginData({ ...loginData, password: e.target.value })} />
        <button onClick={handleLogin}>Anmelden</button>
      </div>
    );

  const visible = currentUser.role === "admin" ? inspections : inspections.filter(i => i.erstelltVon === currentUser.email);

  return (
    <div className="wrapper">
      <div className="header">
        <h1>📝 Inspektionen ({currentUser.role})</h1>
        <div>
          <button className="toggle-theme" onClick={() => document.body.classList.toggle("dark")}>🌗 Design</button>
          <button className="logout-button" onClick={() => { setCurrentUser(null); localStorage.removeItem("sc_user"); }}>🚪 Logout</button>
        </div>
      </div>

      <div className="nav-buttons">
        <button className={view === "list" ? "nav-button active" : "nav-button"} onClick={() => setView("list")}>📋 Übersicht</button>
        <button className={view === "form" ? "nav-button active" : "nav-button"} onClick={() => setView("form")}>➕ Neu</button>
      </div>

      {view === "form" ? (
        <form className="form" onSubmit={handleSubmit}>
          <label>Ort:<input required value={form.ort} onChange={(e) => setForm({ ...form, ort: e.target.value })} /></label>
          <label>Kategorie:<input value={form.kategorie} onChange={(e) => setForm({ ...form, kategorie: e.target.value })} /></label>
          <label>Beschreibung:<textarea value={form.beschreibung} onChange={(e) => setForm({ ...form, beschreibung: e.target.value })} /></label>
          <label>Dringlichkeit:
            <select value={form.dringlichkeit} onChange={(e) => setForm({ ...form, dringlichkeit: e.target.value })}>
              <option value="hoch">🔴 Hoch</option>
              <option value="mittel">🟠 Mittel</option>
              <option value="niedrig">🟢 Niedrig</option>
            </select>
          </label>
          <label>Bilder:
            <input type="file" accept="image/*" multiple onChange={handleImageUpload} />
          </label>
          <div className="form-buttons">
            <button type="submit" className="primary-button">✅ Speichern</button>
            <button type="button" onClick={() => setView("list")}>❌ Abbrechen</button>
          </div>
        </form>
      ) : (
        <div className="card-list">
          {visible.length === 0 ? <p className="empty-text">Keine Einträge</p> : visible.map((entry, i) => (
            <div className="card" key={i}>
              <div className="card-header">
                <strong>{entry.ort}</strong> – {entry.kategorie || "(ohne Kategorie)"}
              </div>
              <div className="card-content">
                <p>{entry.beschreibung}</p>
                <p className="meta">⏱️ {entry.dringlichkeit} | 🧾 Status: {entry.status}</p>
                <p className="meta">👤 {entry.erstelltVon} – 🕒 {entry.erstelltAm}</p>
                {entry.bilder.length > 0 && <div className="images">{entry.bilder.map((src, j) => <img key={j} src={src} alt="Bild" />)}</div>}
              </div>
              {currentUser.role === "admin" && (
                <div className="card-actions">
                  <select value={entry.status} onChange={(e) => handleUpdate(i, "status", e.target.value)}>
                    <option>Neu</option>
                    <option>In Bearbeitung</option>
                    <option>Abgeschlossen</option>
                  </select>
                  <button onClick={() => handleDelete(i)} className="logout-button">🗑️ Löschen</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
